<template>
    <div class="wrapper">
        <TopLanguageSelector></TopLanguageSelector>
        
        <header>
            <h1><img class="title_logo img-fluid" src="../assets/logo.png" alt="減災教室"/></h1>
        </header>
      
        <main class="container">
            <div class="catchcopy">
                <h2 class="point" v-html="body.catchcopy.point"></h2>
                <p class="short" v-html="body.catchcopy.short"></p>
                <h2 class="try" v-html="body.catchcopy.try"></h2>
                <img src="../assets/takagi/1.png" width="30%" height="30%" class="img-fluid"/>
            </div>

            <TopLevelSelectors v-for="(info, i) in body.levelSelectors" :info="info" :key="i" />

            <p class="privacy-policy-title" v-text="body.privacyPolicy"></p>
            <div id="maindisp" style="height: 400px; background-color: rgba(255, 255, 255, 0.8)" >
                <iframe src="../../policy.html" id="policy" class="privacy-policy-iframe" name="privacy-policy-iframe" width="70%" height="40%"></iframe>
            </div>
        </main>

        <footer class="copyrights">
			編著：岐阜大学教授 髙木朗義<br>
			製作：岐阜高専コンピューター倶楽部<br>
			企画：一般社団法人 Do It Yourself<br>
	    </footer>
    </div>
</template>

<script>
import top from '../assets/json/top.json'
import TopLevelSelectors from './TopLevelSelectors'
import TopLanguageSelector from './parts/TopLanguageSelector'

export default {
    components: {
        TopLevelSelectors,
        TopLanguageSelector
    },
    props: [
        'lang'
    ],
    data: function() {
        return {
            /* 問題フォルダから自動的に取得できるようにしたい */
            /* 問題集のタイトル、提供元、リンク先などの情報 */
            top: top
        };
    },
    computed: {
        body: function() {
            if(this.$props.lang === "en"){
                return top.en;
            }else if(this.$props.lang === "cn"){
                return top.cn;
            }else if(this.$props.lang === "pt"){
                return top.pt;
            }else if(this.$props.lang === "sn"){
                return top.sn;
            }else if(this.$props.lang === "tg"){
                return top.tg;
            }else{
                console.log(top);
                return top.jp;
            }
                
            
        }
    }
}
</script>

<style>
    @import "../assets/css/top.css";
    @import url(http://fonts.googleapis.com/earlyaccess/notosansjapanese.css);
    
    body::before{
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        position: fixed;
        font-family: 'Noto Sans JP', sans-serif;
        font-size:200%;
        font-weight: 300;
        animation: fadeIn 0.3s ease-in 0s 1 normal;
        -webkit-animation: fadeIn 0.3s ease 0s 1 normal;
        background-image: url("../assets/background.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% auto;
        display: block;
        padding-bottom: 108px;
        content: "";
        z-index: -1;
    }

    header{
        text-align: center;
        margin-top:6vh;
        margin-bottom:3vh;
        animation: fadeIn 0.5s ease-in 0s 1 normal;
        -webkit-animation: fadeIn 1s ease 0s 1 normal;
    }

    .privacy-policy-iframe {
        width:100%;
        height:100%;
        border:none; /* 追加で指定 */
        display:block; /* 追加で指定 */
    }

    .privacy-policy-title{
        text-align: center;
    }

    .copyrights{
        margin-top: 10px;
        font-size: 14px;
        text-align: center;
    }

    .Rdot{
        border-bottom:#FF0000 dotted medium;
    }

    .Gdot{
        border-bottom:medium #00FF00 dotted;
    }

    .Bdot{
        border-bottom:medium #0000FF dotted;
    }

    #button{
        margin-bottom:4vh;
        margin-top:2vh;
        animation: fadeIn 3s cubic-bezier(0.1, 0.83, 0.58, 1) 0s 1 normal;
        -webkit-animation: fadeIn 3s cubic-bezier(0.1, 0.83, 0.58, 1) 0s 1 normal;
    }

    h3{
        font-size: 250%;
        animation: fadeIn 0.3s ease-in 0s 1 normal;
        -webkit-animation: fadeIn 0.3s ease 0s 1 normal;
    }

    .lang_controll{
        text-align: right;
    }

    .lang_btn{
        width: 10%;
    }

    .catchcopy{
        text-align: center;
    }

    h2.try{
        margin: 10px 0;
        text-align: center;
    }

    h2.point{
        animation: fadeIn 5s linier 0s 1 normal;
        -webkit-animation: fadeIn 5s ease 0s 1 normal;
        padding: 20px 0;
        word-wrap: break-word;
    }

    p.short{
        animation: fadeIn 7s ease 0s 1 normal;
        -webkit-animation: fadeIn 7s ease 0s 1 normal;
        word-wrap: break-word;
        line-height: 38px;
    }

    p.short_en{
        animation: fadeIn 7s ease 0s 1 normal;
        -webkit-animation: fadeIn 7s ease 0s 1 normal;
        word-wrap: break-word;
        line-height: 20px;
    }

    #maindisp{
        border:0.5px #888888 solid;
        width:story;
        height:story;
        overflow:auto; 
        -webkit-overflow-scrolling:touch;
        border:1px solid #c9c9c9;
        margin-left: 5%;
        margin-right: 5%;
        height: 400px; 
        background-color: #ffffffcc;
    }


    @keyframes fadeIn {
        0% {opacity: 0}
        100% {opacity: 1}
    }

    @-webkit-keyframes fadeIn {
        0% {opacity: 0}
        100% {opacity: 1}
    }
    @keyframes fadeIn { /*「fadeIn」と名前をそろえる*/
        0% {opacity: 0} /*アニメーション開始時は完全に透過*/
        100% {opacity: 1} /*アニメーション終了時は透過しない*/
    }

    /*旧 Safari 用のベンダー処理*/
    @-webkit-keyframes fadeIn {
        0% {opacity: 0}
        100% {opacity: 1}
    }





</style>